import { render, staticRenderFns } from "./FooterEmilia.vue?vue&type=template&id=28ac8bb3&scoped=true&"
import script from "./FooterEmilia.vue?vue&type=script&lang=js&"
export * from "./FooterEmilia.vue?vue&type=script&lang=js&"
import style0 from "./FooterEmilia.vue?vue&type=style&index=0&id=28ac8bb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ac8bb3",
  null
  
)

export default component.exports